import React from 'react';
import {Link} from 'react-router-dom';
import {ArrowRightIcon, ClockIcon, HangerIcon, PlayIcon, ScanIcon, SparklesIcon} from '../icons';
import AppMockup from './AppMockup';
import {HERO, HERO_BENEFITS} from './content';
import {LandingCta} from './cta';

const BENEFIT_ICONS = [ScanIcon, SparklesIcon, ClockIcon, HangerIcon];

/**
 * Hero: ценностное предложение, две CTA и мокап продукта.
 * Единственный `<h1>` страницы живёт здесь (UI-6).
 *
 * Заголовок работает как якорь всей композиции: он крупнее всего остального на
 * странице с большим отрывом, поэтому первый экран читается за пару секунд.
 * Кикера над ним нет — заголовок несёт себя сам.
 */
const LandingHero: React.FC<{cta: LandingCta}> = ({cta}) => (
    <section
        className="relative overflow-hidden bg-gradient-to-b from-brand-50/70 to-transparent dark:from-brand-500/5 dark:to-transparent"
        aria-labelledby="landing-hero-title"
    >
        <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6 pt-14 md:pt-20 pb-20 md:pb-28">
            <div className="grid lg:grid-cols-[1.05fr_1fr] gap-12 lg:gap-10 items-center">
                <div className="min-w-0">
                    <h1
                        id="landing-hero-title"
                        className="text-[2.75rem] sm:text-6xl xl:text-[4.5rem] font-bold leading-[0.98] tracking-[-0.04em]
                                   text-ink-900 dark:text-ink-50 text-balance"
                    >
                        {HERO.titleLead}
                        <br/>
                        {HERO.titleSecond}{' '}
                        <span className="text-brand-600 dark:text-brand-400">{HERO.titleAccent}</span>
                    </h1>
                    <p className="mt-7 text-lg sm:text-xl leading-8 text-ink-600 dark:text-ink-300 max-w-[34ch]">
                        {HERO.description}
                    </p>

                    <div className="mt-9 flex flex-col sm:flex-row gap-3">
                        <Link to={cta.primary.href} className="btn-accent h-12 text-[15px]">
                            {cta.primary.label}
                            <ArrowRightIcon className="w-4 h-4"/>
                        </Link>
                        <a href="#how" className="btn-secondary h-12 text-[15px]">
                            <span className="w-6 h-6 rounded-full border border-brand-500 flex items-center justify-center">
                                <PlayIcon className="w-3 h-3 text-brand-600 dark:text-brand-400"/>
                            </span>
                            {HERO.secondaryCta}
                        </a>
                    </div>

                    <ul className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-x-4 gap-y-3">
                        {HERO_BENEFITS.map((benefit, index) => {
                            const Icon = BENEFIT_ICONS[index];
                            return (
                                <li key={benefit} className="flex items-center gap-2 text-xs text-ink-600 dark:text-ink-300">
                                    <Icon className="w-4 h-4 text-brand-500 shrink-0"/>
                                    <span className="min-w-0">{benefit}</span>
                                </li>
                            );
                        })}
                    </ul>
                </div>

                <div className="min-w-0 lg:pl-4">
                    <AppMockup/>
                </div>
            </div>
        </div>
    </section>
);

export default LandingHero;
